// import _ from 'underscore';

class Listener {

	constructor({ app }) {
		this.app = app;
		this.store = app.$store;
		// this.$broadcaster = app.$broadcaster;
		this.channels = [];
	}

	subscribe() {
		// if (this.store.getters.currentAccount) {
		// 	// Initial Setup
		// 	this.onAccountChange(this.store.getters.currentAccount.id, false);
		// }
		//
		// this.store.subscribe((mutation, state) => {
		// 	switch (mutation.type) {
		// 		case 'setCurrentAccount':
		// 			this.onAccountChange(state.auth.currentAccountId);
		// 			break;
		// 		case 'setToken':
		// 			this.$broadcaster.config.auth.headers.Authorization = `Bearer ${ mutation.payload }`;
		// 			break;
		// 		case 'setUser':
		// 			// Login
		// 			break;
		// 		case 'logout':
		// 			// Logout
		// 			this.onAccountChange(null, true);
		// 			break;
		// 	}
		// });
	}

	onAccountChange(accountId, ) {
		if (accountId) {
			// this.listenToAccount(accountId);
		}
	}

	// listenToAccount(accountId) {
	// 	const channelName = 'private-account.' + accountId;
	// 	if (_.pluck(this.channels, 'name').indexOf(channelName) !== -1) return; // Already subscribed
	//
	// 	const channel = this.$broadcaster.subscribe(channelName);
	// 	this.channels.push({ name: channelName, accountId });
	//
	// 	channel.bind('account.updated', (data) => {
	// 		this.store.dispatch('accountUpdated', data.account);
	// 	});
	// }
}

export default {

	// When everything is ready to go !
	ready(context) {
		if (!process.client) return;

		const listeners = new Listener(context);
		listeners.subscribe();


	},

};
